module.exports = __webpack_public_path__ + "static/media/illustration_george_app.d1ce04ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustration_george_app.svg
// module id = 337
// module chunks = 21